import { render, staticRenderFns } from "./ScoreDialog.vue?vue&type=template&id=e227d4c8&scoped=true"
import script from "./ScoreDialog.vue?vue&type=script&lang=js"
export * from "./ScoreDialog.vue?vue&type=script&lang=js"
import style0 from "./ScoreDialog.vue?vue&type=style&index=0&id=e227d4c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e227d4c8",
  null
  
)

export default component.exports